//External Dependencies
import React, { Component } from "react";
//Internal Dependencies
import { DemandOrderProvider } from "./context/DemandOrderContext";
import AsyncComponent from "../../../components/async-component";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import PageContent from "../../../components/page-content";
import PageWrap from "../../../components/page-wrap";

//Component
class DemandOrders extends Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <DemandOrderProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </DemandOrderProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default DemandOrders;
